import { useTranslation } from "react-i18next";
import { Modal } from "@arco-design/web-react";

import './ConfirmationDialog.css';

type Props = {
  visible: boolean;
  text: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmationDialog({ visible, text, onConfirm, onCancel }: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      simple
      cancelText={t('common.no_text')}
      okText={t('common.ok_text')}
      onCancel={onCancel}
      onOk={onConfirm}
      cancelButtonProps={{ shape: 'round', className: "confirmation-dialog__button confirmation-dialog__button-secondary" }}
      okButtonProps={{ shape: 'round', className: "confirmation-dialog__button" }}
      className="confirmation-dialog"
    >
      <div className="confirmation-dialog__text">{text}</div>
    </Modal>
  )
}